import { ApolloClient, InMemoryCache, from } from '@apollo/client';
import { loadDevMessages, loadErrorMessages } from '@apollo/client/dev';

import { errorLink } from './links/errorLink';
import { httpLink } from './links/httpLink';
import { retryLink } from './links/retryLink';
import { scalarsLink } from './links/scalarsLink';

import { urlBuilder } from '../utils/urlBuilder';

if (process.env.NODE_ENV !== 'production') {
  loadDevMessages();
  loadErrorMessages();
}

// Builds a new Apollo Client instance. This can be used in tests and
// Storybook stories to create isolated instances.
export const buildClient = () =>
  new ApolloClient({
    link: from([retryLink, errorLink, scalarsLink, httpLink(urlBuilder.graphQL(), {})]),
    cache: new InMemoryCache(),
    connectToDevTools: true,
    defaultOptions: {
      query: {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
      },
      mutate: {
        errorPolicy: 'all',
        fetchPolicy: 'network-only',
      },
      watchQuery: {
        errorPolicy: 'all',
        fetchPolicy: 'cache-and-network',
      },
    },
  });

// Singleton Apollo Client instance for use in the app.
export const client = buildClient();
